export const BasicLockIcon = ({ style }: { style?: React.CSSProperties }) => (
  <span
    className="material-icons-outlined"
    style={{
      marginLeft: "4px",
      marginTop: "4px",
      fontSize: "16px",
      ...style,
    }}
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    lock
  </span>
);
export default BasicLockIcon;
